<template>
  <div>
    <span
      class="scroll-to-top"
      :class="[cartQuantity > 0 ? 'bottom-135' : '']"
      @click="handleScrollToTopClick"
      v-if="showScrollToTop"
    >
      <i class="hkfi-back rotate90clockwise color-white fs-12 bold"></i>
    </span>
  </div>
</template>
<script>
import debounce from "lodash/debounce";
import {
  keyMapsGetter,
} from "../helpers/storeKeys";
export default {
  name: "ScrollToTopFloatingButton",
  data() {
    return {
      showScrollToTop: false,
    };
  },
  mounted() {
    window.addEventListener(
      "scroll",
      debounce(this.handleScrollEventListener, 1000)
    );
  },
  methods: {
    toggleShowScrollToTop() {
      this.showScrollToTop = !this.showScrollToTop;
    },
    handleScrollToTopClick(e) {
      this.toggleShowScrollToTop();
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    handleScrollEventListener() {
      if (window.pageYOffset > 1 && !this.showScrollToTop) {
        this.toggleShowScrollToTop();
      }
      if (window.pageYOffset < 1 && this.showScrollToTop) {
        this.toggleShowScrollToTop();
      }
    },
  },
  computed:{
    cartQuantity() {
      return this.$store.getters[keyMapsGetter.CART_QUANTITY];
    },
  }
};
</script>

<style></style>
